import { useCallback, useEffect, useRef, useState } from 'react';
import { Layout } from '../../../components/Layout';
import { SEOData, SEODataProps } from '../../../components/SEOData';
import { ControlSection } from './components/ControlSection';
import { FAQsSection } from './components/FAQsSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { HeroSection } from './components/HeroSection';
import { StickyHeroCta } from './components/StickyHeroCta';
import { InYourFixSection } from './components/InYourFixSection';
import { PricingSection } from './components/PricingSection';
import { StylistMatchSection } from './components/StylistMatchSection';
import { brandsValuePageData } from './data';
type BrandsValuePageProps = {
  seoData?: SEODataProps;
};
const BrandsValuePage = ({
  seoData = {}
}: BrandsValuePageProps) => {
  const {
    hero,
    pricing,
    stylistMatch,
    inYourFix,
    control,
    finalCta,
    faqs
  } = brandsValuePageData;
  const heroRef = useRef<HTMLElement | null>(null);
  const [footerTarget, setFooterTarget] = useState<HTMLDivElement | null>(null);
  const [isHeroInView, setIsHeroInView] = useState(true);
  const [isFooterInView, setIsFooterInView] = useState(false);
  const setHeroTarget = useCallback((node: HTMLElement | null) => {
    heroRef.current = node;
  }, []);
  useEffect(() => {
    if (!heroRef.current || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === heroRef.current) {
          setIsHeroInView(entry.isIntersecting);
        }
        if (entry.target === footerTarget) {
          setIsFooterInView(entry.isIntersecting);
        }
      });
    });
    observer.observe(heroRef.current);
    if (footerTarget) {
      observer.observe(footerTarget);
    }
    return () => {
      observer.disconnect();
    };
  }, [footerTarget]);
  return <Layout footerRef={setFooterTarget}>
      <SEOData {...seoData} />
      <HeroSection hero={hero} sectionRef={setHeroTarget} />
      <PricingSection data={pricing} />
      <InYourFixSection data={inYourFix} />
      <StylistMatchSection data={stylistMatch} />
      <ControlSection data={control} />
      <FinalCtaSection data={finalCta} />
      <FAQsSection data={faqs} />
      <StickyHeroCta ctaLabel={hero.ctaLabel} ctaHref={hero.ctaHref} isHidden={isHeroInView || isFooterInView} />
    </Layout>;
};
export default BrandsValuePage;